"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createGetRequestOpts = exports.createPutRequestOpts = exports.createPostRequestOpts = exports.createDeleteRequestOpts = void 0;
const utils_1 = require("./utils");
function createBaseRequestOpts(method, opts) {
    const { apikey, headers, csrfToken, ...restOpts } = opts;
    return {
        ...restOpts,
        headers: (0, utils_1.createHeaders)({
            Accept: "application/json",
            "ARGUS-API-KEY": apikey,
            "Argus-CSRF-Token": csrfToken || false,
            "Content-type": "application/json",
            ...(headers || {}),
        }),
        method,
        mode: "cors",
        ...(!apikey && { credentials: "include" }), // Either apikey or credentials
    };
}
/**
 * Create DELETE request
 *
 * @param opts optional API key, CSRF token, extraHeaders
 */
function createDeleteRequestOpts(opts) {
    return {
        ...createBaseRequestOpts("DELETE", opts),
    };
}
exports.createDeleteRequestOpts = createDeleteRequestOpts;
/**
 * Create POST request
 *
 * @param body
 * @param opts optional API key, CSRF token, extraHeaders
 */
function createPostRequestOpts(body, opts) {
    return {
        ...createBaseRequestOpts("POST", opts),
        body,
    };
}
exports.createPostRequestOpts = createPostRequestOpts;
/**
 * Create PUT request
 *
 * @param body  The body of the request
 * @param opts  optional API key, CSRF token, extraHeaders
 */
function createPutRequestOpts(body, opts) {
    return {
        ...createBaseRequestOpts("PUT", opts),
        body,
    };
}
exports.createPutRequestOpts = createPutRequestOpts;
/**
 * Create GET request
 *
 * @param opts Optional apikey and extraHeaders
 */
function createGetRequestOpts(opts) {
    return {
        ...createBaseRequestOpts("GET", opts),
        redirect: "follow",
    };
}
exports.createGetRequestOpts = createGetRequestOpts;
